import { d as colors } from "./focus-DaIphPOd.mjs";
import { l as radii, u as shadows } from "./motion-Cg-JnSSP.mjs";
import "react";
import { jsx, jsxs } from "react/jsx-runtime";
//#region effects/GlassPanel.tsx
const blurMap = {
	sm: "8px",
	md: "20px",
	lg: "40px"
};
const intensityMap = {
	light: "rgba(28, 28, 31, 0.4)",
	medium: "rgba(28, 28, 31, 0.6)",
	heavy: "rgba(28, 28, 31, 0.8)"
};
function GlassPanel({ blur, intensity, bordered, style, children, ...props }) {
	const b = blur ?? "md";
	const i = intensity ?? "medium";
	const bord = bordered ?? true;
	return /* @__PURE__ */ jsxs("div", {
		style: {
			background: intensityMap[i],
			backdropFilter: `blur(${blurMap[b]})`,
			WebkitBackdropFilter: `blur(${blurMap[b]})`,
			borderRadius: radii.lg,
			borderWidth: bord ? 1 : 0,
			borderStyle: bord ? "solid" : "none",
			borderColor: bord ? colors.glassBorder : "transparent",
			boxShadow: shadows.glass,
			position: "relative",
			overflow: "hidden",
			...style
		},
		...props,
		children: [/* @__PURE__ */ jsx("div", { style: {
			position: "absolute",
			inset: 0,
			borderRadius: "inherit",
			pointerEvents: "none",
			boxShadow: `
            inset 0 1px 0 rgba(255, 255, 255, 0.05),
            inset 0 -1px 0 rgba(0, 0, 0, 0.1)
          `
		} }), children]
	});
}
//#endregion
export { GlassPanel as t };

//# sourceMappingURL=GlassPanel-Cf6NZdLp.mjs.map